<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Perfis</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataPerfis"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              @click="handleGoToNewRole"
              color="orangePcm"
              href="/controle-de-acesso/roles/criar"
              target="_blank"
            >
              Criar Perfil
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field
              v-model="search"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Busca"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <div>
              <v-tooltip bottom v-if="item.id !== 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    :href="`/controle-de-acesso/roles/atualizar/${item.id}`"
                    v-bind="attrs"
                    v-on="on"
                    @click="atualizarButton(item, $event)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.id !== 1 && permissaoTotal">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="darkRed"
                    v-bind="attrs"
                    v-on="on"
                    @click="deletar(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Perfis: {{ qtdRoles }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ListPagination from "@/componentes/ListPagination";
import Snackbar from "@/componentes/Snackbar";
import { registerVuexModule } from "@/utils/vuexUtils";
import { pagesHomeMixins } from "@/mixins/pagesHomeMixins";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import perfisStore from "../_store";
import perfisHttpService from "../_services/perfisHttpService";

export default {
  components: { ListPagination, Snackbar },

  mixins: [pagesHomeMixins],

  data: () => ({
    text: "",
    snackbar: false,
    headers: [
      {
        text: "Perfil",
        value: "name",
        align: "left",
      },
      {
        text: "Ações",
        value: "botoes",
        align: "center",
        sortable: false,
      },
    ],
    dataPerfis: [],
    permissaoTotal: false,
    arrayPermissoesTotal: [
      process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_TOTAL,
      process.env.VUE_APP_ADMINISTRADOR,
    ],
  }),

  computed: {
    ...mapGetters("perfisHomeModuleUsersStore", ["getAllRoles"]),

    numberOfPages() {
      return Math.ceil(this.dataPerfis.length / this.itemsPerPage);
    },
    qtdRoles() {
      return this.dataPerfis.length;
    },
  },

  async created() {
    registerVuexModule(this.$store, "perfisHomeModuleUsersStore", perfisStore);

    await this.listAllRoles();
    this.dataPerfis = [...this.getAllRoles];

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    arrayPermissions.forEach((permissaoLocalStorage) => {
      if (this.arrayPermissoesTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true;
      }
    });
    this.showSkeleton = false;
  },

  methods: {
    ...mapActions("perfisHomeModuleUsersStore", ["listAllRoles"]),
    ...obtainUserPermissions,

    handleGoToNewRole(event) {
      event.preventDefault();
      if (event.metaKey || event.ctrlKey) {
        const goToNewRole = this.$router.resolve({ name: "roles/criar" });
        window.open(goToNewRole.href, "_blank");
      } else {
        this.$router.push({ name: "roles/criar" });
      }
    },

    atualizar(event, item) {
      if (item.item.id !== 1) {
        if (event.metaKey || event.ctrlKey) {
          const updatePath = this.$router.resolve(
            `roles/atualizar/${item.item.id}`
          );
          window.open(updatePath.href, "_blank");
        } else {
          this.$router.push(`roles/atualizar/${item.item.id}`);
        }
      }
    },

    atualizarButton(item, event) {
      event.preventDefault();
      if (item.id !== 1) {
        if (event.metaKey || event.ctrlKey) {
          const updatePath = this.$router.resolve(`roles/atualizar/${item.id}`);
          window.open(updatePath.href, "_blank");
        } else {
          this.$router.push(`roles/atualizar/${item.id}`);
        }
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o perfil "${item.name}"?`);
      if (resultado) {
        try {
          const response = await perfisHttpService.deleteRole(item.id);
          if (typeof response === "undefined") {
            this.text =
              "Verifique se este perfil está sendo usado por outro usuário antes de deletá-lo.";
            this.snackbar = true;
            return;
          }
          this.dataPerfis = this.dataPerfis.filter((x) => x.id !== item.id);
        } catch (error) {
          alert(error.response.data);
        }
      }
    },
  },
};
</script>
